import { render } from "./ProgramDSSCriterionDataTable.vue?vue&type=template&id=2cbc5eb0&scoped=true"
import script from "./ProgramDSSCriterionDataTable.vue?vue&type=script&lang=js"
export * from "./ProgramDSSCriterionDataTable.vue?vue&type=script&lang=js"

import "./ProgramDSSCriterionDataTable.vue?vue&type=style&index=0&id=2cbc5eb0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cbc5eb0"]])

export default __exports__